<template>
  <v-simple-table v-if="publications.length > 0" fixed-header>
    <template #default>
      <thead>
        <tr>
          <th class="text-left">{{ $t("menu.validate.list.type") }}</th>
          <th class="text-left">{{ $t("menu.validate.list.date") }}</th>
          <th class="text-left">{{ $t("menu.validate.list.url") }}</th>
          <th class="text-left">{{ $t("menu.validate.list.action") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="p in publications" :key="p.key" :title="p.message">
          <td :title="$t(`menu.validate.type.${p.type}`)" class="text-center">
            <v-icon v-if="p.type === 1" small>fa-sticky-note</v-icon>
            <v-icon v-else-if="p.type === 2" small>fa-photo-video</v-icon>
            <v-icon v-else-if="p.type === 3" small>fa-question</v-icon>
            <v-icon v-else-if="p.type === 4" small>fa-reply</v-icon>
          </td>
          <td>{{ p.date | moment("from") }}</td>
          <td>
            <a :href="p.url">{{ p.domain }}</a>
          </td>
          <td class="text-center">
            <div class="tw-flex tw-justify-between">
              <v-btn :title="$t('menu.validate.list.validate')" color="success" text x-small @click="validate(p)">
                <v-icon x-small>fa-check</v-icon>
              </v-btn>
              <v-btn :title="$t('menu.validate.list.reject')" color="error" text x-small @click="reject(p)">
                <v-icon x-small>fa-trash</v-icon>
              </v-btn>
            </div>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
  <div v-else>{{ $t("menu.validate.list.empty") }}</div>
</template>

<script>
export default {
  name: "ValidatePublications",
  data: () => ({
    publications: [],
  }),
  mounted() {
    this.fetchPublications()
  },
  methods: {
    validate(publication) {
      this.$axios
        .post("office/me/publications/validate", {
          id: publication.raw.id,
          database: publication.raw.database,
        })
        .then(() => {
          this.publications = this.publications.filter(p => p.key !== publication.key)
        })
    },
    reject(publication) {
      this.$axios
        .post("office/me/publications/reject", {
          id: publication.raw.id,
          database: publication.raw.database,
        })
        .then(() => {
          this.publications = this.publications.filter(p => p.key !== publication.key)
        })
    },
    formatData(publications) {
      this.publications = publications.map(publication => ({
        raw: publication,
        type: publication.type,
        key: publication.id + publication.database,
        date: publication.created_at,
        url: publication.url.full_path,
        domain: publication.domain.host,
        message: publication.message,
      }))
    },
    fetchPublications() {
      this.$axios.get("office/me/publications").then(response => {
        this.formatData(response.data)
      })
    },
  },
}
</script>
